import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { SubstanceDTO } from '../../_models/SubstanceDTO';
import { ParametreService } from '../../../services/parametre-service/parametre.service';
import { CommonModule, DatePipe, NgForOf, NgIf } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatOption } from '@angular/material/core';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';
import { ProductPesticideMRL } from '../../_models/ProductPesticideMRL';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-activeSubstance',
  standalone: true,
  imports: [
          MatCardModule,CommonModule,MatPaginator, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
          MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput, MatDatepicker,
          MatDatepickerInput, MatDatepickerToggle, MatSuffix, MatSortModule, MatInputModule, MatOption, MatSelect, NgForOf, DatePipe, MatCheckbox
      ],
  templateUrl: './activeSubstance.component.html',
  styleUrl: './activeSubstance.component.scss'
})

export class ActiveSubstanceComponent implements AfterViewInit {
  substances: SubstanceDTO[] = [];
  isLoading: boolean = true; 
  errorMessage: string = ''; // Indicateur pour afficher un loader pendant le chargement

  groupedProductPesticides: ProductPesticideMRL[] = [];
  displayedColumns: string[] = ['productName', 'productCode', 'pesticideName', 'mrlValue'];
  dataSource = new MatTableDataSource<ProductPesticideMRL>([]); // Initialise avec un tableau vide ou tes données
  searchValue: string = ''

  @ViewChild(MatPaginator) paginator: MatPaginator | null = null;
  originalProductPesticides:  ProductPesticideMRL[] = [];

  constructor(private parameterService: ParametreService,       
              public themeService: CustomizerSettingsService) {}

  ngOnInit() {
    this.getProductPesticideData();
    this.initializePaginatorAndSort();

  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator; // Liaison du paginator avec la dataSource
  }

  initializePaginatorAndSort() {
    this.dataSource.filter = this.searchValue
    this.dataSource.paginator = this.paginator;
}

getProductPesticideData(): void {
  this.parameterService.getProductPesticideMRLs().subscribe((data: any) => {
    console.log('Données retournées par l\'API:', data);

    // Regroupement des produits et de leurs pesticides par productCode
    if (Array.isArray(data)) {
      const productMap = new Map<string, any>(); // Clé : productCode, valeur : produit avec pesticides

      data.forEach((item: any) => {
        const { productName, productCode, pesticideName, mrlValue } = item;

        if (!productMap.has(productCode)) {
          productMap.set(productCode, {
            productName: productName || 'Produit inconnu',
            productCode: productCode,
            pesticides: []
          });
        }

        // Ajoute le pesticide au tableau des pesticides du produit
        productMap.get(productCode)?.pesticides.push({
          pesticideResidueName: pesticideName || 'Non spécifié',
          mrlValueOnly: mrlValue != null ? mrlValue : 'Non spécifié'
        });
      });

      // Convertir la Map en tableau
      this.groupedProductPesticides = Array.from(productMap.values());
      this.originalProductPesticides = [...this.groupedProductPesticides]; // Stocker les données non filtrées
      this.dataSource.data = this.groupedProductPesticides;

      console.log('groupedProductPesticides après regroupement:', this.groupedProductPesticides);
    } else {
      console.error('Les données reçues ne sont pas un tableau valide', data);
    }
  }, error => {
    console.error('Erreur lors de la récupération des données:', error);
  });
}


    // Méthode pour rafraîchir les données
    refreshProductPesticideData(): void {
      this.parameterService.refreshProductPesticideMRLs().subscribe(
        (data: any) => {
          console.log('Données après rafraîchissement:', data);
          this.getProductPesticideData();  // Rafraîchir les données après la mise à jour
          this.isLoading = false;  // Cacher l'indicateur de chargement
        },
        (error) => {
          console.error('Erreur lors du rafraîchissement des données:', error);
          this.isLoading = false;  // Cacher l'indicateur de chargement même en cas d'erreur
          this.errorMessage = 'Une erreur est survenue lors du rafraîchissement des données.';
        }
      );
    }
    searchProductValue: string = '';
    searchPesticideValue: string = '';

    filterData() {
      const productName = this.searchProductValue?.toLowerCase().trim() || '';
      const pesticideName = this.searchPesticideValue?.toLowerCase().trim() || '';
    
      console.log('🔍 Valeur recherchée - Produit:', productName);
      console.log('🔍 Valeur recherchée - Pesticide:', pesticideName);
    
      const filtered = this.originalProductPesticides.reduce((acc, product) => {
        const matchProduct = productName
          ? product.productName.toLowerCase().includes(productName)
          : true;
    
        const filteredPesticides = product.pesticides.filter(pesticide =>
          pesticideName
            ? pesticide.pesticideResidueName.toLowerCase().includes(pesticideName)
            : true
        );
    
        const matchPesticide = filteredPesticides.length > 0;
    
        console.log('🔬 Pesticides correspondants :', filteredPesticides);
    
        if (matchProduct && matchPesticide) {
          acc.push({
            ...product,
            pesticides: filteredPesticides
          });
        }
    
        return acc;
      }, [] as ProductPesticideMRL[]);
    
      console.log('📦 Résultats filtrés:', filtered);
    
      this.groupedProductPesticides = filtered;
      this.dataSource.data = [...this.groupedProductPesticides]; // Mettre à jour la dataSource si utilisée
    }
    
    
    
    applyFilter(event: Event) {
      this.searchProductValue = (event.target as HTMLInputElement).value;
      this.filterData();
    }
    
    applyPesticideFilter(event: Event) {
      this.searchPesticideValue = (event.target as HTMLInputElement).value;
      this.filterData();
    }
    

   
}
